<template>
    <div v-if="visible">
        <el-dialog title="班级评价统计详情" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div class="container">
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    v-loading="loading"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border>
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="gradeName" label="年级名称"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="className" label="班级名称"  :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="" label="值"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div v-if="scope.row.medalCount!=null ">
                                {{scope.row.medalCount}}枚/{{scope.row.score}}分
                            </div>
                            <div v-else>
                                {{scope.row.score}}分
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="common.page"
                        :page-size="common.pageSize"
                        :page-sizes="common.allSizes"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="common.total">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    startDate:"",
                    endDate:"",
                },
                data:[],
            }
        },
        created:function () {
        },
        methods:{
            init(id,startDate,endDate){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=id;
                this.form.startDate=startDate;
                this.form.endDate=endDate;
                // 获取数据列表
                this.data=[];
                this.common.page=1;
                this.getData();
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateDetailArchiveInfoListtUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    id:this.form.id,
                    startDate:this.form.startDate,
                    endDate:this.form.endDate,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }else{
                    return true;
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluateArchive/ClassEvaluateInfo.vue